/**
 * Utilitários para formatação de códigos de identificação
 */

/**
 * Gera código de incidente baseado no ID
 * @param {number} id - ID do incidente
 * @returns {string} Código formatado (ex: "INC-1")
 */
export const formatIncidentCode = (id) => {
  if (!id) return 'N/A';
  return `INC-${id}`;
};

/**
 * Gera código de ticket do service desk baseado no ID
 * @param {number} id - ID do ticket
 * @returns {string} Código formatado (ex: "SD-1")
 */
export const formatTicketCode = (id) => {
  if (!id) return 'N/A';
  return `SD-${id}`;
};

/**
 * Extrai o ID numérico de um código formatado
 * @param {string} code - Código formatado (ex: "INC-1", "SD-2")
 * @returns {number|null} ID numérico ou null se inválido
 */
export const extractIdFromCode = (code) => {
  if (!code) return null;
  const match = code.match(/^(INC|SD)-(\d+)$/);
  return match ? parseInt(match[2], 10) : null;
};
